<template>
  <NuxtLayout :name="layout">
    <section class="p-error">
      <div class="container l-container">
        <img
          v-if="error.statusCode === 404"
          src="/static/images/error-404.png"
          alt="404"
        />
        <img
          v-else-if="error.statusCode === 429"
          src="/static/images/error-429.png"
          alt="429"
        />
        <img v-else src="/static/images/error-500.png" alt="500" />
        <div>
          <template v-if="error.statusCode === 404">
            <h1 class="text-h1-bold-up">
              К сожалению,<br />
              страница не найдена
            </h1>
            <p class="text-body-m-book">
              Возможно, вы ввели неправильный адрес или страница была удалена.
              Воспользуйтесь поиском или перейдите на
              <span class="p_link" @click="handleError">
                главную страницу.
              </span>
            </p>
          </template>
          <template v-else-if="error.statusCode === 429">
            <h1 class="text-h1-bold-up">
              Похоже, с вашего<br />
              адреса поступило слишком<br />
              много запросов
            </h1>
            <p class="text-body-m-book">
              Попробуйте перезагрузить страницу или вернуться на
              <span class="p_link" @click="handleError"> главную. </span>
            </p>
          </template>
          <template v-else>
            <h1 class="text-h1-bold-up">
              К сожалению,<br />
              произошла ошибка
            </h1>
            <p class="text-body-m-book">
              Наши специалисты уже занимаются решением проблемы. Попробуйте
              обновить страницу или зайти позже
            </p>
          </template>
        </div>
      </div>
    </section>
  </NuxtLayout>
</template>
<script setup>
import { useGlobalStore } from '~/stores/global';

const globalStore = useGlobalStore();
const props = defineProps({
  error: [String, Object],
});
const layout = computed(() => {
  return globalStore.emptyLayout ? 'empty' : 'default';
});
const handleError = () => clearError({ redirect: '/' });
onBeforeUnmount(() => {
  clearError();
});
onMounted(() => {
  console.error('page props error', props.error);
});
</script>

<style scoped lang="scss">
.p-error {
  background-color: $achromatic-card-bg;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1 0 auto;
  padding: 20px 0 96px;
  margin-bottom: -40px;

  @include md-block {
    padding: 140px 0 251px;
  }
  @include lg-block {
    margin-bottom: -64px;
    padding: 84px 0 160px;
  }

  img {
    object-fit: contain;
    width: 146px;
    height: 146px;
    margin-right: 0;
    margin-bottom: 24px;

    @include md-block {
      width: 213px;
      height: 213px;
      margin-right: 8px;
      margin-bottom: 0;
    }
    @include lg-block {
      width: 324px;
      height: 324px;
      margin-right: 66px;
    }
    @include xl-block {
      width: 411px;
      height: 411px;
      margin-right: 82px;
    }
  }

  h1 {
    width: 296px;
    margin-bottom: 16px;
    @include md-block {
      width: 286px;
    }
    @include lg-block {
      width: 519px;
      margin-bottom: 24px;
    }
    @include xl-block {
      width: 657px;
    }
  }

  p {
    width: 296px;

    @include lg-block {
      width: 472px;
    }
  }

  .container {
    display: flex;
    padding: 20px 0;
    align-items: center;
    justify-content: center;
    max-width: 100%;
    flex-direction: column;
    text-align: center;

    @include md-block {
      flex-direction: row;
      text-align: left;
    }
  }
}
</style>
